/**
 * ****************************************************************************
 * @description     :   Store menu
 * @created at      :   2024/10/11
 * @created by      :   ANS376 – daonx@ans-net.co.jp
 * @package         :   Move version 2
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

// import repository from './repository';
const appVersion = process.env.VUE_APP_VERSION;

const dataPreviewInit = {
    listMenu: {
        MNG: {
            list: [
                ...(appVersion == '1.5'
                    ? [
                          {
                              name: 'MNG_System001',
                              to: '/MNG_System001',
                              class: '',
                              title: 'TOP'
                          },
                          {
                              name: 'MNG_Order001',
                              relatedName: ['MNG_Order002', 'MNG_Order003'],
                              class: '',
                              title: '受注管理',
                              children: {
                                  class: '',
                                  list: [
                                      {
                                          name: 'MNG_Order004',
                                          to: '/MNG_Order004',
                                          class: '',
                                          notIconArrow: true,
                                          title: '未処理検索'
                                      },
                                      {
                                          name: 'MNG_Order001',
                                          to: '/MNG_Order001',
                                          class: '',
                                          notIconArrow: true,
                                          title: '全受注検索 '
                                      }
                                  ]
                              }
                          },
                          {
                              name: 'MNG_Client001',
                              relatedName: ['MNG_Client002'],
                              class: '',
                              title: 'お客様管理',
                              children: {
                                  class: '',
                                  list: [
                                      {
                                          name: 'MNG_Client009',
                                          to: '/MNG_Client009',
                                          class: '',
                                          notIconArrow: true,
                                          title: '新規お客様確認'
                                      },
                                      {
                                          name: 'MNG_Client001',
                                          to: '/MNG_Client001',
                                          class: '',
                                          notIconArrow: true,
                                          title: '会社管理'
                                      },
                                      {
                                          name: 'MNG_Client003',
                                          relatedName: ['MNG_Client004'],
                                          to: '/MNG_Client003',
                                          class: '',
                                          notIconArrow: true,
                                          title: '発注拠点管理'
                                      }
                                  ]
                              }
                          },
                          {
                              name: 'prevent',
                              relatedName: [
                                  'MNG_Master001',
                                  'MNG_Master002',
                                  'MNG_Master003',
                                  'MNG_Master003_Detail',
                                  'MNG_Master004',
                                  'MNG_Master004_Detail',
                                  'MNG_Master005',
                                  'MNG_Master005_Detail'
                              ],
                              class: '',
                              title: 'マスタ管理',
                              children: {
                                  class: '',
                                  list: [
                                      {
                                          name: 'MNG_Master001',
                                          relatedName: ['MNG_Master002'],
                                          to: '/MNG_Master001',
                                          class: '',
                                          notIconArrow: true,
                                          title: 'マスタ一覧'
                                      },
                                      {
                                          name: 'MNG_Master003',
                                          relatedName: ['MNG_Master003_Detail'],
                                          to: '/MNG_Master003',
                                          class: '',
                                          notIconArrow: true,
                                          title: '持ち物マスタ'
                                      },
                                      {
                                          name: 'MNG_Master004',
                                          relatedName: ['MNG_Master004_Detail'],
                                          to: '/MNG_Master004',
                                          class: '',
                                          notIconArrow: true,
                                          title: '統括部マスタ'
                                      },
                                      {
                                          name: 'MNG_Client007',
                                          relatedName: ['MNG_Client008'],
                                          to: '/MNG_Client007',
                                          class: '',
                                          notIconArrow: true,
                                          title: '社員管理マスタ'
                                      },
                                      {
                                          name: 'MNG_Master005',
                                          relatedName: ['MNG_Master005_Detail'],
                                          to: '/MNG_Master005',
                                          class: '',
                                          notIconArrow: true,
                                          title: '現場担当者マスタ'
                                      },
                                      {
                                          name: 'MNG_Client010',
                                          to: '/MNG_Client010',
                                          class: '',
                                          notIconArrow: true,
                                          title: '料金表アップロード'
                                      },
                                      {
                                          name: 'MNG_MasterFAQ',
                                          to: '/MNG_MasterFAQ',
                                          class: '',
                                          notIconArrow: true,
                                          title: 'FAQマスタ'
                                      }
                                  ]
                              }
                          },
                          {
                              name: 'MNG_System004',
                              relatedName: ['MNG_System005'],
                              to: '/MNG_System004',
                              class: '',
                              title: 'メッセージ一覧'
                          },
                          {
                              name: 'MNG_File001',
                              relatedName: ['MNG_File002'],
                              to: '/MNG_File001',
                              class: '',
                              title: 'ファイルアップロード'
                          },
                          {
                              name: 'CUS_FAQ',
                              newTab: true,
                              to: '/CUS_FAQ',
                              class: '',
                              title: 'ヘルプセンター'
                          }
                      ]
                    : [
                          {
                              name: 'MNG_System001',
                              to: '/MNG_System001',
                              class: '',
                              title: 'TOP'
                          },
                          {
                              name: 'MNG_Order001',
                              relatedName: ['MNG_Order002', 'MNG_Order003'],
                              class: '',
                              title: '受注管理',
                              children: {
                                  class: '',
                                  list: [
                                      {
                                          name: 'MNG_Order004',
                                          to: '/MNG_Order004',
                                          class: '',
                                          notIconArrow: true,
                                          title: '未処理検索'
                                      },
                                      {
                                          name: 'MNG_Order001',
                                          to: '/MNG_Order001',
                                          class: '',
                                          notIconArrow: true,
                                          title: '全受注検索 '
                                      },
                                      {
                                          name: 'MNG_Order005',
                                          to: '/MNG_Order005',
                                          class: '',
                                          notIconArrow: true,
                                          title: 'タスク検索 '
                                      },
                                      {
                                          name: 'MNG_Order006',
                                          to: '/MNG_Order006',
                                          class: '',
                                          notIconArrow: true,
                                          title: '受注検索 '
                                      },
                                      {
                                          name: 'MNG_Order008',
                                          to: '/MNG_Order008',
                                          class: '',
                                          notIconArrow: true,
                                          title: '見積検索 '
                                      }
                                  ]
                              }
                          },
                          {
                              name: 'MNG_Contact001',
                              relatedName: ['MNG_Contact002', 'MNG_Contact003'],
                              class: '',
                              title: '確認連絡',
                              children: {
                                  class: '',
                                  list: [
                                      {
                                          name: 'MNG_Contact001',
                                          to: '/MNG_Contact001',
                                          class: '',
                                          notIconArrow: true,
                                          title: '確認連絡'
                                      }
                                  ]
                              }
                          },
                          {
                              name: 'MNG_Client001',
                              relatedName: ['MNG_Client002'],
                              class: '',
                              title: 'お客様管理',
                              children: {
                                  class: '',
                                  list: [
                                      {
                                          name: 'MNG_Client009',
                                          to: '/MNG_Client009',
                                          class: '',
                                          notIconArrow: true,
                                          title: '新規お客様確認'
                                      },
                                      {
                                          name: 'MNG_Client001',
                                          to: '/MNG_Client001',
                                          class: '',
                                          notIconArrow: true,
                                          title: '会社管理'
                                      },
                                      {
                                          name: 'MNG_Client003',
                                          relatedName: ['MNG_Client004'],
                                          to: '/MNG_Client003',
                                          class: '',
                                          notIconArrow: true,
                                          title: '発注拠点管理'
                                      }
                                  ]
                              }
                          },
                          {
                              name: 'MNG_WorkCheck',
                              class: '',
                              title: '作業チェック',
                              children: {
                                  class: '',
                                  list: [
                                      {
                                          name: 'MNG_WorkCheck001',
                                          to: '/MNG_WorkCheck001',
                                          class: '',
                                          notIconArrow: true,
                                          title: '作業日別検索 '
                                      }
                                  ]
                              }
                          },
                          {
                              name: 'MNG_Staff',
                              relatedName: ['MNG_Staff001', 'MNG_Staff002'],
                              class: '',
                              title: 'スタッフ管理',
                              children: {
                                  class: '',
                                  list: [
                                      {
                                          name: 'MNG_Staff001',
                                          to: '/MNG_Staff001',
                                          class: '',
                                          notIconArrow: true,
                                          title: 'スタッフ情報検索'
                                      },
                                      {
                                          name: 'MNG_Staff002',
                                          to: '/MNG_Staff002',
                                          class: '',
                                          notIconArrow: true,
                                          title: '紹介者検索'
                                      }
                                  ]
                              }
                          },
                          {
                              name: 'MNG_Schedule',
                              relatedName: ['MNG_Schedule020', 'MNG_Schedule001'],
                              class: '',
                              title: 'スケジュール管理',
                              children: {
                                  class: '',
                                  list: [
                                      {
                                          name: 'MNG_Schedule020',
                                          to: '/MNG_Schedule020',
                                          class: '',
                                          notIconArrow: true,
                                          title: 'スケジュール（スマホ）'
                                      },
                                      {
                                          name: 'MNG_Schedule001（月）',
                                          to: '/MNG_Schedule001',
                                          class: '',
                                          notIconArrow: true,
                                          title: 'スケジュール（月）',
                                          routeNameRelative: 'MNG_Schedule001',
                                          routeProps: { section: 'views', views: 'month' }
                                      },
                                      {
                                          name: 'MNG_Schedule001（週）',
                                          to: '/MNG_Schedule001',
                                          class: '',
                                          notIconArrow: true,
                                          title: 'スケジュール（週）',
                                          routeNameRelative: 'MNG_Schedule001',
                                          routeProps: { section: 'views', views: 'week' }
                                      },
                                      {
                                          name: 'MNG_Schedule001（グループA）',
                                          to: '/MNG_Schedule001',
                                          class: '',
                                          notIconArrow: true,
                                          title: 'スケジュール（グループA）',
                                          routeNameRelative: 'MNG_Schedule001',
                                          routeProps: { section: 'groups', views: 'groupA' }
                                      },
                                      {
                                          name: 'MNG_Schedule001（グループB）',
                                          to: '/MNG_Schedule001',
                                          class: '',
                                          notIconArrow: true,
                                          title: 'スケジュール（グループB）',
                                          routeNameRelative: 'MNG_Schedule001',
                                          routeProps: { section: 'groups', views: 'groupB' }
                                      },
                                      {
                                          name: 'MNG_Schedule001',
                                          to: '/MNG_Schedule001',
                                          class: '',
                                          notIconArrow: true,
                                          title: 'スケジュール（設備(月)）',
                                          routeNameRelative: 'MNG_Schedule001',
                                          routeProps: { section: 'equipments', views: 'equipmentMonth' }
                                      },
                                      {
                                          name: 'MNG_Schedule001',
                                          to: '/MNG_Schedule001',
                                          class: '',
                                          notIconArrow: true,
                                          title: 'スケジュール（設備(週)）',
                                          routeNameRelative: 'MNG_Schedule001',
                                          routeProps: { section: 'equipments', views: 'equipmentWeek' }
                                      },
                                      {
                                          name: 'MNG_Schedule002',
                                          to: '/MNG_Schedule002',
                                          class: '',
                                          notIconArrow: true,
                                          title: '設備一覧'
                                      },
                                      {
                                          name: 'MNG_Schedule011',
                                          to: '/MNG_Schedule011',
                                          class: '',
                                          notIconArrow: true,
                                          title: '設備予約登録'
                                      }
                                  ]
                              }
                          },
                          {
                              name: 'MNG_Accident',
                              relatedName: ['MNG_Accident001', 'MNG_Accident002', 'MNG_Accident003', 'MNG_Accident004'],
                              class: '',
                              title: '事故報告',
                              children: {
                                  class: '',
                                  list: [
                                      {
                                          name: 'MNG_Accident001',
                                          to: '/MNG_Accident001',
                                          class: '',
                                          notIconArrow: true,
                                          title: '事故一覧'
                                      },
                                      {
                                          name: 'MNG_Accident003',
                                          to: '/MNG_Accident003',
                                          class: '',
                                          notIconArrow: true,
                                          title: '事故報告一覧'
                                      },
                                      {
                                          name: 'MNG_Accident004',
                                          to: '/MNG_Accident004',
                                          class: '',
                                          notIconArrow: true,
                                          title: '事故報告共有'
                                      }
                                  ]
                              }
                          },
                          {
                              name: 'MNG_Billing',
                              relatedName: ['MNG_Billing001'],
                              class: '',
                              title: '請求',
                              children: {
                                  class: '',
                                  list: [
                                      {
                                          name: 'MNG_Billing001',
                                          to: '/MNG_Billing001',
                                          class: '',
                                          notIconArrow: true,
                                          title: '請求一覧'
                                      }
                                  ]
                              }
                          },
                          {
                              name: 'MNG_Attendance',
                              relatedName: ['MNG_Attendance001'],
                              class: '',
                              title: '勤怠管理',
                              children: {
                                  class: '',
                                  list: [
                                      {
                                          name: 'MNG_Attendance001',
                                          to: '/MNG_Attendance001',
                                          class: '',
                                          notIconArrow: true,
                                          title: '勤怠登録'
                                      }
                                  ]
                              }
                          },
                          {
                              name: 'prevent',
                              relatedName: [
                                  'MNG_Master001',
                                  'MNG_Master002',
                                  'MNG_Master003',
                                  'MNG_Master003_Detail',
                                  'MNG_Master004',
                                  'MNG_Master004_Detail',
                                  'MNG_Master005',
                                  'MNG_Master005_Detail'
                              ],
                              class: '',
                              title: 'マスタ管理',
                              children: {
                                  class: '',
                                  list: [
                                      {
                                          name: 'MNG_Master001',
                                          relatedName: ['MNG_Master002'],
                                          to: '/MNG_Master001',
                                          class: '',
                                          notIconArrow: true,
                                          title: 'マスタ一覧'
                                      },
                                      {
                                          name: 'MNG_Master003',
                                          relatedName: ['MNG_Master003_Detail'],
                                          to: '/MNG_Master003',
                                          class: '',
                                          notIconArrow: true,
                                          title: '持ち物マスタ'
                                      },
                                      {
                                          name: 'MNG_Master004',
                                          relatedName: ['MNG_Master004_Detail'],
                                          to: '/MNG_Master004',
                                          class: '',
                                          notIconArrow: true,
                                          title: '統括部マスタ'
                                      },
                                      {
                                          name: 'MNG_Client007',
                                          relatedName: ['MNG_Client008'],
                                          to: '/MNG_Client007',
                                          class: '',
                                          notIconArrow: true,
                                          title: '社員管理マスタ'
                                      },
                                      {
                                          name: 'MNG_Master005',
                                          relatedName: ['MNG_Master005_Detail'],
                                          to: '/MNG_Master005',
                                          class: '',
                                          notIconArrow: true,
                                          title: '現場担当者マスタ'
                                      },
                                      {
                                          name: 'MNG_Client010',
                                          to: '/MNG_Client010',
                                          class: '',
                                          notIconArrow: true,
                                          title: '料金表アップロード'
                                      },
                                      {
                                          name: 'MNG_MasterFAQ',
                                          to: '/MNG_MasterFAQ',
                                          class: '',
                                          notIconArrow: true,
                                          title: '[FAQ]メッセージマスタ'
                                      },
                                      {
                                          name: 'MNG_MasterFAQKeyword',
                                          to: '/MNG_MasterFAQKeyword',
                                          class: '',
                                          notIconArrow: true,
                                          title: '[FAQ]キーワードマスタ'
                                      },
                                      {
                                          name: '権限管理',
                                          to: '/MNG_Authority_Management',
                                          class: '',
                                          notIconArrow: true,
                                          title: '権限管理'
                                      }
                                  ]
                              }
                          },
                          {
                              name: 'MNG_System004',
                              relatedName: ['MNG_System005'],
                              to: '/MNG_System004',
                              class: '',
                              title: 'メッセージ一覧'
                          },
                          {
                              name: 'MNG_WorkReport',
                              relatedName: ['MNG_WorkReport001'],
                              class: '',
                              title: '作業報告',
                              children: {
                                  class: '',
                                  list: [
                                      {
                                          name: 'MNG_WorkReport001',
                                          to: '/MNG_WorkReport001',
                                          class: '',
                                          notIconArrow: true,
                                          title: '業務日報一覧'
                                      },
                                      {
                                          name: 'MNG_SalesReport001',
                                          to: '/MNG_SalesReport001',
                                          class: '',
                                          notIconArrow: true,
                                          title: '営業報告一覧'
                                      }
                                  ]
                              }
                          },
                          {
                              name: 'MNG_WorkerInfo',
                              relatedName: [
                                  'MNG_WorkerInfo001',
                                  'MNG_WorkerInfo002',
                                  'MNG_WorkerInfo003',
                                  'MNG_WorkerInfo004',
                                  'MNG_WorkerInfo005',
                                  'MNG_WorkerInfo006'
                              ],
                              class: '',
                              title: '手配管理',
                              children: {
                                  class: '',
                                  list: [
                                      {
                                          name: 'MNG_WorkerInfo001',
                                          to: '/MNG_WorkerInfo001',
                                          class: '',
                                          notIconArrow: true,
                                          title: '「手配」受注情報検索'
                                      },
                                      {
                                          name: 'MNG_WorkerInfo005',
                                          to: '/MNG_WorkerInfo005',
                                          class: '',
                                          notIconArrow: true,
                                          title: '「手配」スケジュール検索'
                                      }
                                  ]
                              }
                          },
                          {
                              name: 'MNG_Equipment',
                              relatedName: ['MNG_Equipment001', 'MNG_Equipment002', 'MNG_Equipment003', 'MNG_Equipment004'],
                              class: '',
                              title: '備品管理',
                              children: {
                                  class: '',
                                  list: [
                                      {
                                          name: 'MNG_Equipment001',
                                          to: '/MNG_Equipment001',
                                          class: '',
                                          notIconArrow: true,
                                          title: '備品一覧'
                                      },
                                      //   {
                                      //       name: 'MNG_Equipment002',
                                      //       to: '/MNG_Equipment002',
                                      //       class: '',
                                      //       notIconArrow: true,
                                      //       title: '備品登録'
                                      //   },
                                      {
                                          name: 'MNG_Equipment003',
                                          to: '/MNG_Equipment003',
                                          class: '',
                                          notIconArrow: true,
                                          title: '備品棚卸表'
                                      },
                                      {
                                          name: 'MNG_Equipment004',
                                          to: '/MNG_Equipment004',
                                          class: '',
                                          notIconArrow: true,
                                          title: '備品カテゴリー'
                                      }
                                  ]
                              }
                          },
                          {
                              name: 'MNG_AuthorApp',
                              relatedName: ['MNG_AuthorApp001', 'MNG_AuthorApp002', 'MNG_AuthorApp003'],
                              class: '',
                              title: '電子承認',
                              children: {
                                  class: '',
                                  list: [
                                      {
                                          name: 'MNG_AuthorApp002',
                                          to: '/MNG_AuthorApp002',
                                          class: '',
                                          notIconArrow: true,
                                          title: '申請一覧'
                                      },
                                      {
                                          name: 'MNG_AuthorApp003',
                                          to: '/MNG_AuthorApp003',
                                          class: '',
                                          notIconArrow: true,
                                          title: '承認一覧'
                                      },
                                      {
                                          name: 'MNG_AuthorApp001',
                                          to: '/MNG_AuthorApp001',
                                          class: '',
                                          notIconArrow: true,
                                          title: '承認ルート設定'
                                      }
                                  ]
                              }
                          },
                          {
                              name: 'MNG_WorkerStaff',
                              relatedName: ['MNG_WorkerStaff001', 'MNG_WorkerStaff002'],
                              class: '',
                              title: '案件サイト',
                              children: {
                                  class: '',
                                  list: [
                                      {
                                          name: 'MNG_WorkerStaff001',
                                          to: '/MNG_WorkerStaff001',
                                          class: '',
                                          notIconArrow: true,
                                          title: '案件サイト申込チェック'
                                      },
                                      {
                                          name: 'MNG_WorkerStaff002',
                                          to: '/MNG_WorkerStaff002',
                                          class: '',
                                          notIconArrow: true,
                                          title: '確認スタッフ検索'
                                      }
                                  ]
                              }
                          },
                          {
                              name: 'MNG_WorkerStaff',
                              relatedName: ['MNG_Uriage001', 'MNG_Uriage002', 'MNG_Uriage003'],
                              class: '',
                              title: '売上管理',
                              children: {
                                  class: '',
                                  list: [
                                      {
                                          name: 'MNG_Uriage001',
                                          to: '/MNG_Uriage001',
                                          class: '',
                                          notIconArrow: true,
                                          title: '締日別請求情報検索'
                                      },
                                      {
                                          name: 'MNG_Uriage002',
                                          to: '/MNG_Uriage002',
                                          class: '',
                                          notIconArrow: true,
                                          title: 'エリア別売上検索'
                                      },
                                      {
                                          name: 'MNG_Uriage003',
                                          to: '/MNG_Uriage003',
                                          class: '',
                                          notIconArrow: true,
                                          title: '連携用売上出力'
                                      }
                                  ]
                              }
                          },
                          {
                              name: 'MNG_File001',
                              relatedName: ['MNG_File002'],
                              to: '/MNG_File001',
                              class: '',
                              title: 'ファイルアップロード'
                          },
                          {
                              name: 'CUS_FAQ',
                              newTab: true,
                              to: '/CUS_FAQ',
                              class: '',
                              title: 'ヘルプセンター'
                          }
                      ])
            ]
        },
        CUS: {
            list: [
                {
                    name: 'CUS_System001',
                    to: '/CUS_System001',
                    class: '',
                    title: 'TOP'
                },
                // {
                //     name: 'CUS_Order001',
                //     to: '/CUS_Order001',
                //     class: '',
                //     title: '簡単見積'
                // },
                {
                    name: 'CUS_Order011',
                    relatedName: ['CUS_Order012', 'CUS_Order013', 'CUS_Order014', 'CUS_Order015', 'CUS_Order016'],
                    to: '/CUS_Order011',
                    class: '',
                    title: '申込(依頼・見積)'
                },
                {
                    name: 'CUS_Order021',
                    relatedName: ['CUS_Order022', 'CUS_Order023'],
                    to: '/CUS_Order021',
                    class: '',
                    title: '申込状況検索'
                },
                {
                    name: 'CUS_Delivery001',
                    to: '/CUS_Delivery001',
                    class: '',
                    title: '納品書'
                },
                {
                    name: 'CUS_Billing001',
                    to: '/CUS_Billing001',
                    class: '',
                    title: '請求書'
                },
                {
                    name: 'CUS_Client003',
                    relatedName: ['CUS_Client004'],
                    to: '/CUS_Client003',
                    class: '',
                    title: '発注拠点管理'
                },
                {
                    name: 'CUS_System003',
                    relatedName: ['CUS_System003_Detail'],
                    to: '/CUS_System003',
                    class: '',
                    title: '担当者一覧'
                },
                {
                    name: 'CUS_System002',
                    to: '/CUS_System002',
                    class: '',
                    title: '個人設定'
                },
                // {
                //     name: 'CUS_Register001',
                //     to: '/CUS_Register001',
                //     class: '',
                //     title: 'お客様登録'
                // },
                // {
                //     name: 'CUS_Start001',
                //     to: '/CUS_Start001',
                //     class: '',
                //     title: 'お客様利用前設定'
                // },
                {
                    name: 'CUS_Master001',
                    to: '/CUS_Master001',
                    class: '',
                    title: 'テンプレートマスタ'
                },
                {
                    name: 'CUS_Start005',
                    to: '/CUS_Start005',
                    class: '',
                    title: 'お問い合わせ'
                },
                // {
                //     name: 'MNG_File003',
                //     to: '/MNG_File003',
                //     class: '',
                //     title: '料金表PDF'
                // }
                {
                    name: 'CUS_FAQ',
                    newTab: true,
                    to: '/CUS_FAQ',
                    class: '',
                    title: 'ヘルプセンター'
                }
            ]
        }
    }
};
export default {
    namespaced: true,
    state: {
        listMenu: { ...dataPreviewInit.listMenu.CUS }
    },
    mutations: {
        resetDataInit(state) {
            state.data = { ...dataPreviewInit };
        },
        setListMenuLeft(state, newData) {
            state.listMenu = newData;
        }
    },
    actions: {
        async fetchMenuLeft(context, page) {
            try {
                const responseItems = await new Promise((resolve) => {
                    resolve({
                        ...dataPreviewInit.listMenu[page]
                    });
                });
                context.commit('setListMenuLeft', responseItems);
            } catch (e) {
                console.log('fetchMenuLeft: ' + e.message);
            }
        }
        // updateMenuLeft(context, newData) {
        //     try {
        //         context.commit('setListMenuLeft', newData);
        //     } catch (e) {
        //         console.log('Action get data order detail: ' + e.message);
        //     }
        // },
        // referItem(context, input) {
        //     try {
        //         repository.getDataFile(input).then((res) => {
        //             const { data } = res;
        //             if (data.Code === 200) {
        //                 if (input.callback) {
        //                     input.callback(data);
        //                 }
        //             } else if (data.Code === 422) {
        //                 if (input.onErrorValidate) {
        //                     input.onErrorValidate(data.Message);
        //                 }
        //             } else {
        //                 if (input.onError) {
        //                     input.onError(data.Data.message);
        //                 }
        //             }
        //         });
        //     } catch (e) {
        //         console.log('Action get data order detail: ' + e.message);
        //     }
        // }
    }
};
